import { Hex } from "./mechanics";
import { CartesianCoordinates } from "../types/geometry";

export const hexReduceRatio = 1; //0.95;
export const hexratio = 0.8660254037844387; // height of a hex equilateral triangle of side 1
export const sideLength = 1;

const heightReductionRatio = 0.15;

export const iconsSizeReduction = 0.58;

export const hexPolygonPoints =
  "0.8660254037844387,-0.49999999999999994 0.8660254037844387,0.49999999999999994 6.123233995736766e-17,1 -0.8660254037844387,0.49999999999999994 -0.8660254037844386,-0.5000000000000001 -1.8369701987210297e-16,-1";

// const hside = 0.8660254037844387;
// const vside = 1;
export const paddingViewport = 0.1;

export const cube2cartesian = (coordinates: Hex): CartesianCoordinates => ({
  x: (2 * coordinates.q + coordinates.r) * sideLength * hexratio,
  y: coordinates.r * 1.5 * sideLength,
});

export const pointyHexCorner = (
  center: { x: number; y: number },
  size: number,
  i: number
): CartesianCoordinates => {
  const angle_rad = (Math.PI / 180) * 60 * i - 30;
  return {
    x: center.x + size * Math.cos(angle_rad),
    y: center.y + size * Math.sin(angle_rad),
  };
};

export const boardBounds = (
  pieceCoords: CartesianCoordinates[]
): {
  bounds: { xmin: number; xmax: number; ymin: number; ymax: number };
  w: number;
  h: number;
} => {
  let [xmin, xmax, ymin, ymax] = [0, 0, 0, 0];
  pieceCoords.forEach((c) => {
    if (c.x < xmin) {
      xmin = c.x;
    }
    if (c.x > xmax) {
      xmax = c.x;
    }
    if (c.y < ymin) {
      ymin = c.y;
    }
    if (c.y > ymax) {
      ymax = c.y;
    }
  });
  xmin = xmin - sideLength * 2.5 * hexratio;
  xmax = xmax + sideLength * 2.5 * hexratio;
  ymin = ymin - sideLength * 2.5;
  ymax = ymax + sideLength * 2.5;
  return { bounds: { xmin, xmax, ymin, ymax }, w: xmax - xmin, h: ymax - ymin };
};

export const hexRenderPosition = ({
  coords,
  h,
  transform: { scale, min, offsetInDiv },
}: {
  coords: CartesianCoordinates;
  h?: number;
  transform: {
    scale: number;
    min: { x: number; y: number };
    offsetInDiv: { X: number; Y: number };
  };
}) => {
  const x = (coords.x - min.x) * scale + offsetInDiv.X;
  const y = (coords.y + -min.y) * scale + offsetInDiv.Y;
  const hexSide =
    sideLength * scale * hexReduceRatio * (1 - (h || 0) * heightReductionRatio);

  const width = 2 * hexSide * hexratio;
  const height = 2 * hexSide;
  const left = x - hexSide * hexratio; //+ strokeOffset / 2;
  const top = y - hexSide; //+ strokeOffset / 2;
  return { width, height, top, left };
};
